import { useSyncExternalStore } from 'react';
import { AnyFunction } from 'types';

// https://react.dev/learn/you-might-not-need-an-effect#subscribing-to-an-external-store
function subscribe(callback: AnyFunction) {
  window.addEventListener('online', callback);
  window.addEventListener('offline', callback);

  return () => {
    window.removeEventListener('online', callback);
    window.removeEventListener('offline', callback);
  };
}

export function useIsOnline() {
  return useSyncExternalStore(subscribe, () => navigator.onLine);
}
